// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__358aO","field":"styles_field__2_MZf","fieldCol":"styles_fieldCol__145CX","diffCol":"styles_diffCol__2MXT9","diff":"styles_diff__3fyWV"};